module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/chart/pie-rose-chart/pie-rose-chart.component.less
// module id = ./src/app/shared/components/chart/pie-rose-chart/pie-rose-chart.component.less
// module chunks = main